export default function formatRouter (word) {
  return word.replace(/\s/g, '_').toLowerCase()
}
